import React from 'react';
import PropTypes from 'prop-types';
import { Translate, I18n } from 'react-redux-i18n';

const SyncHistoryModal = ({ open, account, onClose }) => {
    if (!open || !account) {
        return null;
    }

    const history = Array.isArray(account.sync_history) ? account.sync_history : [];

    const handleBackdropClick = (event) => {
        if (event.target === event.currentTarget) {
            onClose();
        }
    };

    return (
        <div
            className="settings-broker-modal-overlay"
            onClick={handleBackdropClick}
            role="presentation"
        >
            <div
                className="settings-broker-modal"
                role="dialog"
                aria-modal="true"
                aria-labelledby="broker-sync-history-title"
            >
                <div className="settings-broker-modal-header">
                    <div>
                        <h4 id="broker-sync-history-title">
                            <Translate value="broker_sync_history" />
                        </h4>
                        <p className="settings-broker-hint">
                            <Translate value="broker_account" />
                            {': '}
                            {account.account_number}
                        </p>
                    </div>
                    <button
                        type="button"
                        className="btn btn-text btn-sm"
                        onClick={onClose}
                    >
                        <Translate value="close" />
                    </button>
                </div>

                <div className="settings-broker-modal-body">
                    {history.length === 0 ? (
                        <p className="settings-broker-hint">
                            <Translate value="broker_sync_history_empty" />
                        </p>
                    ) : (
                        <ul className="settings-broker-history-list">
                            {history.map((entry) => (
                                <li
                                    key={entry.id}
                                    className={
                                        entry.status === 'error'
                                            ? 'settings-broker-history-item settings-broker-history-item--error'
                                            : 'settings-broker-history-item'
                                    }
                                >
                                    <div className="settings-broker-history-item-main">
                                        <span>
                                            {entry.sync_from}
                                            {' → '}
                                            {entry.sync_to || '—'}
                                        </span>
                                        <span>
                                            {new Date(entry.synced_at).toLocaleString()}
                                            {entry.is_initial_sync
                                                ? ` (${I18n.t('broker_sync_initial')})`
                                                : ''}
                                        </span>
                                    </div>
                                    {entry.message && (
                                        <p className="settings-broker-history-message">
                                            {entry.message}
                                        </p>
                                    )}
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
        </div>
    );
};

SyncHistoryModal.propTypes = {
    open: PropTypes.bool,
    account: PropTypes.object,
    onClose: PropTypes.func.isRequired,
};

SyncHistoryModal.defaultProps = {
    open: false,
    account: null,
};

export default SyncHistoryModal;
